import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollTooTop = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      setTimeout(() => {
        const target = document.querySelector(location.hash);
        target?.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 0);
      return;
    }

    window.scrollTo(0, 0);
  }, [location]);

  return null;
};

export default ScrollTooTop;
